import { cva } from "class-variance-authority";

export const alertVariants = cva("flex gap-3 px-4 py-3 rounded", {
  variants: {
    kind: {
      warning: "bg-warning-100",
      info: "bg-info-100",
    },
  },
});

export const alertIconVariants = cva(undefined, {
  variants: {
    kind: {
      warning: "text-warning-600",
      info: "text-info-600",
    },
  },
});

export const alertHeaderVariants = cva("font-semibold text-md", {
  variants: {
    kind: {
      warning: "text-warning-800",
      info: "text-info-800",
    },
  },
});
